var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7139 1.28607C13.6657 0.237934 11.9664 0.237979 10.9183 1.28619L1.95577 10.2498C1.65102 10.5546 1.43682 10.9379 1.337 11.3572L0.515307 14.8083C0.470067 14.9983 0.526639 15.1982 0.664759 15.3363C0.802887 15.4744 1.00278 15.531 1.1928 15.4858L4.64373 14.6641C5.06313 14.5642 5.44659 14.3499 5.75143 14.0451L14.714 5.08146C15.762 4.03334 15.762 2.33412 14.7139 1.28607ZM11.7138 2.08163C12.3225 1.47282 13.3096 1.47279 13.9184 2.08157C14.5271 2.6903 14.5272 3.67724 13.9185 4.28601L13.25 4.95459L11.0454 2.75009L11.7138 2.08163ZM10.25 3.54563L12.4545 5.75013L4.95589 13.2496C4.79828 13.4073 4.60001 13.518 4.38316 13.5697L1.82143 14.1796L2.43141 11.6178C2.48301 11.401 2.59376 11.2028 2.75131 11.0452L10.25 3.54563Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.849ee64f86f6718e4c02b8928315f812.svg";
export { ForwardRef as ReactComponent };